var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bi"},[_c('XrkBi',_vm._b({attrs:{"print":_vm.print,"cantEdit":_vm.cantEdit,"projectType":_vm.projectType,"selectType":_vm.selectType,"from":"cso","getTemplateList":_vm.getTemplateList}},'XrkBi',_vm.config,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }